import axios from "axios";
import { getServerProps } from "./server";

let authedAxios = (token = null, userApiKey = null) => {
  const axiosInstance = axios.create({
    baseURL: userApiKey
      ? getServerProps().channex_server
      : getServerProps().base_url,
  });
  // Set default headers
  axiosInstance.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")} `;
  axiosInstance.defaults.headers.common["user-api-key"] = userApiKey;

  // Request interceptor
  axiosInstance.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer ${
      token !== null ? token : `${localStorage.getItem("token")}`
    } `;
    return config;
  });

  // Response interceptor
    const billingRoute = '/hotelx/dashboard/settings/billing';
    const onBillingPage = window.location.pathname === billingRoute;

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 402 && !onBillingPage) {
        // Redirect to billing page
        window.location.href = billingRoute;
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export { authedAxios };
